<template>
  <path
    d="M9.60667 22C4.32667 22 0 17.6733 0 12.3933C0 7.11333 4.32667 2.86 9.60667 2.86H9.97333V12.1H19.2133V12.4667C19.14 17.6733
    14.8867 22 9.60667 22ZM9.24 3.59333C4.47333 3.74 0.733333 7.7 0.733333 12.3933C0.733333 17.3067 4.69333 21.2667 9.60667
    21.2667C14.3733 21.2667 18.26 17.5267 18.4067 12.76H9.24V3.59333ZM22 9.97333H12.0267V0H12.3933C17.6733 0 22 4.32667
    22 9.60667V9.97333ZM12.76 9.24H21.2667C21.0467 4.62 17.38 0.953333 12.76 0.733333V9.24Z"
  />
</template>
